import request from '@/router/axios'
import env from '../../config/env'

/**
 * 获取分页数据
 */
export const getBannerDefaultPage = (data) => {
  return request({
    // url: 'http://192.168.31.65:37579/advertising/default/page',
    url: `${env.ferryUrl}/advertising/default/page`,
    method: 'post',
    data
  })
}

/**
 * 获取banner模板
 */
export const getBannerTemList = (data) => {
  !data && (data = { templateHaveDefaultBanner: false })
  return request({
    // url: 'http://192.168.31.65:37579/advertising/templates',
    url: `${env.ferryUrl}/advertising/templates`,
    method: 'post',
    data
  })
}

/**
 * 判断是否已经有模板
 */
export const judgeBannerTemp = (id) => {
  return request({
    // url: `http://192.168.31.65:37579/advertising/default/has/${id}`,
    url: `${env.ferryUrl}/advertising/default/has/${id}`,
    method: 'get'
  })
}

/**
 * 新增默认banner
 */
export const addDefaultBanner = (data) => {
  return request({
    // url: 'http://192.168.31.65:37579/advertising/default',
    url: `${env.ferryUrl}/advertising/default`,
    method: 'post',
    data
  })
}

/**
 * 修改默认banner状态
 */
export const editDefaultBannerStatus = (data) => {
  return request({
    // url: 'http://192.168.31.65:37579/advertising/default/status',
    url: `${env.ferryUrl}/advertising/default/status`,
    method: 'post',
    data
  })
}

/**
 * 获取模板详情
 */
export const getBannerDetail = (id) => {
  return request({
    // url: `http://192.168.31.65:37579/advertising/default/${id}`,
    url: `${env.ferryUrl}/advertising/default/${id}`,
    method: 'get'
  })
}

/**
 * 编辑模板
 */
export const editDefaultBanner = (data) => {
  return request({
    // url: 'http://192.168.31.65:37579/advertising/default',
    url: `${env.ferryUrl}/advertising/default`,
    method: 'put',
    data
  })
}
